import React, { Fragment, useEffect, useState } from 'react';
import { LogOut } from '../../Constant';
import { Row, Container, CardBody, Card } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPackageDetails } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import { postMasterToken } from '../../Utils/restUtils';
import Transparentspinner from '../../Components/Common/Loader/Transparentspinner';
import HandleHomePageError from '../../Components/Common/ErrorImport/SignError';
import NavSign from '../Sign/NavSign';
import OrderAmount from '../../Components/App/Ecommerce/CheckOut/OrderAmount';
import PackageDetail from '../../Components/App/Ecommerce/CheckOut/PackageDetail';
import { IoMdArrowBack } from "react-icons/io";
import './ApplyCoupon.css';

const ApplyCoupon = () => {
    const location = useLocation();
    const { package_id, company_id } = location.state;
    const authState = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [couponList, setCouponList] = useState('');
    const [taxPer, setTaxPer] = useState('');
    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState({});

    useEffect(() => {
        paymentData();
    }, [])

    const paymentData = async () => {
        setLoading(true);
        const data = await postMasterToken(getPackageDetails, { package_id: package_id.id, industry_id: authState.industryId });
        if (data.status === 200) {
            setDataList(data);
            const list = data.data.data[0];
            setCouponList(list);
            const totalTaxPercentage = list.taxRate.reduce((accumulator, current) => accumulator + current.tax_percentage, 0);
            setTaxPer(totalTaxPercentage);
        }
        else {
            HandleHomePageError(navigate, data.status)
        }
        setLoading(false);
    };

    return (
        <div>
            <NavSign showProfile={true} buttonText={LogOut} />
            <div 
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: "#eff3f9",
                    minHeight: "calc(100vh - 70px)",
                    padding: "20px 0"
                }}
            >
                <Fragment>
                    {loading && <Transparentspinner />}
                    <Container fluid={true} className="container" >

                        <Card className="checkout-main-card">
                            <div>
                                <div className="payment-method-back d-block" onClick={() => navigate('/subscription', { state: { id: company_id } })}>
                                    <div className="d-flex align-items-center">

                                    <IoMdArrowBack size={18} />
                                    </div>
</div>
                            </div>
                            <CardBody className="p-0">
                                <div className="checkout-title-section">
                                    <h1 className="checkout-title">Review your plan and pay</h1>
                                    <p className="checkout-subtitle">
                                        Review your selected plan, choose a payment method, and complete your purchase securely.
                                    </p>
                                </div>
                                <Row className="d-flex justify-content-center align-items-stretch">
                                    <PackageDetail
                                        details={package_id}
                                        features_list={couponList}
                                    />
                                    {Object.keys(dataList).length > 0 &&
                                        <OrderAmount
                                            details={package_id}
                                            datas={dataList}
                                            setLoading={setLoading}
                                            features_list={couponList}
                                            companyId={company_id}
                                        />}
                                </Row >
                            </CardBody>
                        </Card>
                    </Container>
                </Fragment>
            </div>
        </div>
    );
};

export default ApplyCoupon;